import { forwardRef, type Ref, type SVGProps } from "react";
const IconThreeDimensionalFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M3 9.5v11.7a2 2 0 0 0 .9 1.7L15 30.2V16.4zm25-1.7L17 1.4a2.3 2.3 0 0 0-2 0L4 7.8l12 6.9zm-11 8.6v13.8l11.1-7.3a2 2 0 0 0 .9-1.7V9.5z" />
  </svg>
);
const ForwardRef = forwardRef(IconThreeDimensionalFilledSVG);
ForwardRef.displayName = "IconThreeDimensionalFilled";
export { ForwardRef as IconThreeDimensionalFilled };
